import React from "react";
import "./Footer.css";
import logo from "../assets/download.png"

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">

        {/* About Company */}
        <div className="footer-section">
          <div className="logo">
        <img src={logo} alt="Logo" />
        <p>
            We provide high-quality digital solutions, web development, and technology
            services to empower your business with modern tools.
          </p>
      </div>
          
          
          
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><i className="fas fa-home"></i> <a href="/">Home</a></li>
            <li><i className="fas fa-cogs"></i> <a href="/services">Services</a></li>
            <li><i className="fas fa-info-circle"></i> <a href="/about-us">About Us</a></li>
            <li><i className="fas fa-envelope"></i> <a href="/contact">Contact</a></li>
            <li><i className="fas fa-user-shield"></i> <a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3>Contact</h3>
          <p><i className="fas fa-map-marker-alt"></i> Inframart Solutions LLC
5900 Balconies Drive STE # 18335
Austin Texas 7873</p>
          <p><i className="fas fa-envelope"></i> info@inframartsol.com</p>
          
                    <p><i className="fas fa-envelope"></i>inframartsolutions@gmail.com</p>


        </div>

        {/* Social Links */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © 2025 inframart solutions— All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
